export const GET_BONUS_RATE = Symbol('GET_BONUS_RATE');
export const GET_BONUS_RATE_REQUEST = Symbol('GET_BONUS_RATE_REQUEST');
export const GET_BONUS_RATE_SUCCESS = Symbol('GET_BONUS_RATE_SUCCESS');
export const GET_BONUS_RATE_ERROR = Symbol('GET_BONUS_RATE_ERROR');
export const CHANGE_BONUS_RATE = Symbol('CHANGE_BONUS_RATE');
export const CHANGE_BONUS_RATE_REQUEST = Symbol('CHANGE_BONUS_RATE_REQUEST');
export const CHANGE_BONUS_RATE_SUCCESS = Symbol('CHANGE_BONUS_RATE_SUCCESS');
export const CHANGE_BONUS_RATE_ERROR = Symbol('CHANGE_BONUS_RATE_ERROR');